"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VRadio;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./VRadio.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var icon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("rect", {
  x: "0.5",
  y: "0.5",
  width: "23",
  height: "23",
  rx: "11.5",
  stroke: "#A8ADB4"
}));

var checkedIcon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("rect", {
  x: "0.5",
  y: "0.5",
  width: "23",
  height: "23",
  rx: "11.5",
  stroke: "#2F61E0"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "6",
  fill: "#2F61E0"
}));

var useStyles = (0, _styles.makeStyles)({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    position: 'relative',
    borderRadius: '50%',
    border: '1px solid '.concat(_Colors.default.hall1),
    width: 24,
    height: 24,
    '$root.Mui-focusVisible &': {
      outline: 'none',
      outlineOffset: 2
    },
    'input:hover ~ &': {
      borderColor: _Colors.default.sinineVaal,
      transition: 'all 0.4 ease'
    },
    'input:disabled ~ &': {
      borderColor: 'rgba(168, 173, 180, 0.4)'
    }
  },
  checkedIcon: {
    backgroundColor: 'transparent',
    borderColor: _Colors.default.sinineVaal,
    '&:before': {
      content: '""',
      border: 'none',
      position: 'absolute',
      left: '6px',
      top: '6px',
      display: 'block',
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: _Colors.default.sinineVaal
    }
  }
});
/**
 * @visibleName Radio Buttons
 */

function VRadio(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Radio.default, _extends({
    className: classes.root,
    color: "default",
    checkedIcon: checkedIcon,
    icon: icon
  }, props));
}